import React, { useState } from 'react';
import '../styles/Projects.css';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: 'SlideCraft - AI Multi-Agent Presentation Generator',
      description: 'Autonomous multi-agent system that generates professional PowerPoint presentations from a single prompt using LangGraph workflows and local LLM inference.',
      technologies: ['LangGraph', 'LangChain', 'Qwen', 'llama-cpp', 'Streamlit', 'Python'],
      demoImage: '/project-demos/SlideCraft.png',
      githubLink: 'https://github.com/AhmedHossam61/SlideCraft',
      achievements: [
        'Designed autonomous multi-agent system for end-to-end slide generation',
        'Built LangGraph workflows with agents for planning, research, layout, image generation, and rendering',
        'Integrated local LLM inference using Qwen with llama-cpp for privacy-preserving reasoning',
        'Implemented structured JSON schemas separating content from layout',
        'Streamlit interface with real-time agent monitoring and PPTX download'
      ]
    },
    {
      id: 2,
      title: 'Facial Emotion Recognition',
      description: 'CNN-based model for classifying facial emotions with real-time video detection capabilities.',
      technologies: ['TensorFlow', 'CNN', 'OpenCV', 'Python', 'Streamlit'],
      demoImage: '/project-demos/emotioal_recognition.jpg',
      liveLink: 'https://emotion-recognition-ahmed.streamlit.app',
      githubLink: 'https://github.com/AhmedHossam61/facial-emotion-recognition',
      achievements: [
        'Achieved 92% classification accuracy',
        'Processed & augmented 10k+ labeled images',
        'Integrated OpenCV for live video-based emotion detection',
        'Real-time webcam emotion detection'
      ]
    },
    {
      id: 4,
      title: 'Graduation-Project | Capacitive Seat for Cardiovascular Diseases',
      description: 'Smart mobility capstone project combining adaptive drowsiness detection, facial authentication, and ECG anomaly monitoring for safer driving.',
      technologies: ['Mediapipe', 'OpenCV', 'Signal Processing', 'Python'],
      demoImage: '/project-demos/graduation-project.png',
      demoVideo: '/project-demos/graduation-project-demo.mp4',
      githubLink: 'https://github.com/AhmedHossam61/Graduation-Project',
      achievements: [
        'Developed real-time driver drowsiness detection using MediaPipe with adaptive calibration',
        'Implemented driver authentication using facial recognition',
        'Designed ECG signal processing pipelines with anomaly detection and alert systems'
      ]
    }
  ];

  const openDemo = (project) => {
    setSelectedProject(project);
  };

  const closeDemo = () => {
    setSelectedProject(null);
  };

  return (
    <section className="projects" id="projects">
      <div className="container">
        <h2>Selected Projects</h2>
        <p className="projects-intro">
          Here are some of my AI/ML projects with live demos. Click "Try Live Demo" to interact with the applications.
        </p>

        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img src={project.demoImage} alt={project.title} />
                <div className="project-overlay">
                  <button
                    className="demo-btn"
                    onClick={() => openDemo(project)}
                  >
                    View Details
                  </button>
                  {project.liveLink && (
                    <a
                      href={project.liveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="live-demo-btn"
                    >
                      Try Live Demo
                    </a>
                  )}
                </div>
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.liveLink && (
                    <a
                      href={project.liveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="live-link"
                    >
                      Live Demo
                    </a>
                  )}
                  <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedProject && (
          <div className="demo-modal" onClick={closeDemo}>
            <div className="demo-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closeDemo}>x</button>
              <h3>{selectedProject.title}</h3>

              {selectedProject.demoVideo ? (
                <video controls width="100%" style={{ maxHeight: '400px' }}>
                  <source src={selectedProject.demoVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img src={selectedProject.demoImage} alt={selectedProject.title} />
              )}

              <p>{selectedProject.description}</p>

              <div className="project-achievements">
                <h4>Key Achievements:</h4>
                <ul>
                  {selectedProject.achievements.map((achievement, index) => (
                    <li key={index}>{achievement}</li>
                  ))}
                </ul>
              </div>

              <div className="modal-technologies">
                <h4>Technologies Used:</h4>
                <div className="technologies">
                  {selectedProject.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>

              <div className="demo-links">
                {selectedProject.liveLink && (
                  <a
                    href={selectedProject.liveLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="modal-live-btn"
                  >
                    Try Live Demo
                  </a>
                )}
                <a
                  href={selectedProject.githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modal-github-btn"
                >
                  View Code
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;
